import { FC } from 'react';
import { Close } from '@mui/icons-material';
import {
  Button,
  CircularProgress,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
} from '@mui/material';
import classnames from 'classnames';

import getKebabFromString from '@utils/getKebabFromString';

import { IModalProps } from './Modal.interface';
import StyledDialog from './StyledDialog';

import './styles.scss';

const Modal: FC<IModalProps> = ({
  children,
  leftActionTitle,
  onClose,
  onExited,
  onLeftAction,
  onRightAction,
  open,
  rightActionTitle,
  rightActionIcon,
  className,
  title,
  subTitle,
  icon,
  isRightActionDisabled = false,
  isRightActionLoading = false,
  showCloseButton = false,
  submitFormId,
  contentClass,
}) => {
  const modalClasses = classnames('modal', { [`${className}`]: !!className });

  return (
    <StyledDialog
      open={open}
      onClose={onClose}
      aria-labelledby={getKebabFromString(title)}
      aria-describedby={getKebabFromString(title)}
      className={modalClasses}
      TransitionProps={{ onExited }}
      PaperProps={{
        className: 'modal__paper',
      }}
    >
      {showCloseButton && (
        <IconButton className="modal__close-button" onClick={onClose}>
          <Close />
        </IconButton>
      )}

      {title && (
        <DialogTitle id={getKebabFromString(title)} className="modal__title">
          {icon}
          {title}
        </DialogTitle>
      )}

      {subTitle && <h5 className="modal__sub-title">{subTitle}</h5>}

      {children && (
        <DialogContent className={classnames('modal__content', contentClass)}>
          {children}
        </DialogContent>
      )}

      {(onLeftAction || onRightAction || submitFormId) && (
        <DialogActions className="modal__actions">
          {onLeftAction && (
            <Button
              onClick={onLeftAction}
              variant="text"
              className="modal__action modal__action_left"
            >
              {leftActionTitle}
            </Button>
          )}

          {(onRightAction || submitFormId) && (
            <Button
              onClick={onRightAction}
              disabled={isRightActionDisabled || isRightActionLoading}
              variant="contained"
              className="modal__action modal__action_right"
              {...(submitFormId
                ? {
                    type: 'submit',
                    form: submitFormId,
                  }
                : {})}
            >
              {isRightActionLoading ? (
                <CircularProgress
                  className="modal__action-loader"
                  color="inherit"
                  size={16}
                  thickness={5}
                />
              ) : (
                rightActionIcon
              )}
              {rightActionTitle}
            </Button>
          )}
        </DialogActions>
      )}
    </StyledDialog>
  );
};

export default Modal;
